import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  setWrapper: {
    ...theme.mixins.appContainer,
    '&:not(:first-of-type)': {
      marginTop: theme.spacing(1),
    },
  },
  linkWrapper: {
    ...theme.mixins.appLink,
    alignItems: 'flex-start',
    minWidth: 0,
  },
  exerciseTitleInRow: {
    flex: 1,
    minWidth: 0,
    whiteSpace: 'normal',
    overflowWrap: 'anywhere',
    wordBreak: 'break-word',
  },
  programSetTitle: {
    flex: 1,
    minWidth: 0,
    textTransform: 'capitalize',
    whiteSpace: 'normal',
    overflowWrap: 'anywhere',
    wordBreak: 'break-word',
  },
}));
